import { LOCATION_ASSIST_CONFIG_VERSION } from "../../config/locationAssist";

export const LOCATION_ACCURACY_BUCKET = {
  FINE: "fine",
  COARSE: "coarse",
  VERY_COARSE: "very_coarse",
  UNUSABLE: "unusable",
  UNKNOWN: "unknown",
};

export function bucketAccuracyMeters(accuracyMeters) {
  if (typeof accuracyMeters !== "number" || !Number.isFinite(accuracyMeters)) {
    return LOCATION_ACCURACY_BUCKET.UNKNOWN;
  }

  if (accuracyMeters <= 1000) {
    return LOCATION_ACCURACY_BUCKET.FINE;
  }

  if (accuracyMeters <= 25000) {
    return LOCATION_ACCURACY_BUCKET.COARSE;
  }

  if (accuracyMeters <= 500000) {
    return LOCATION_ACCURACY_BUCKET.VERY_COARSE;
  }

  return LOCATION_ACCURACY_BUCKET.UNUSABLE;
}

export function buildRegionRoutingEvidence({
  decision,
  locationSource = null,
  accuracyMeters = null,
  geolocationOutcome = null,
  conflictAcknowledged = false,
} = {}) {
  const safeDecision = decision || {};

  return {
    decision: safeDecision.status || null,
    authoritativeRegion: safeDecision.authoritativeRegionCode || null,
    locationHintRegion: safeDecision.locationHintRegionCode || null,
    resolvedRegion: safeDecision.resolvedRegionCode || null,
    requiresUserResolution: Boolean(safeDecision.requiresUserResolution),
    locationSource: locationSource || null,
    accuracyBucket: bucketAccuracyMeters(accuracyMeters),
    geolocationOutcome:
      typeof geolocationOutcome === "string" && geolocationOutcome.trim()
        ? geolocationOutcome.trim()
        : null,
    conflictAcknowledged: conflictAcknowledged === true,
    configVersion: LOCATION_ASSIST_CONFIG_VERSION,
  };
}
